module.exports = __webpack_public_path__ + "static/img/14.31c2d9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/14.png
// module id = ttwi
// module chunks = 0